import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { formatToPercentage } from '../utils';

const styles = (theme) => ({
  container: {
    display: 'flex',
    color: theme.TextColor,
    flexDirection: 'column-reverse',
    gap: '10px',
    backgroundColor: theme.ModalBGColor,
    padding: 16,
    borderRadius: 4,
    fontSize: theme.textFontSize,
    boxShadow: `0px 2px 4px ${theme.AppBGColor}`,
    fontWeight: 500
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  colorBox: {
    width: 20,
    height: 20,
    borderRadius: 4
  }
});
const TooltipContent = ({ payload, isPercentage, classes }) => {
  const items = Array.isArray(payload) ? payload : [];
  const data = items.map((item) => {
    return {
      name: item.name,
      value: item.value,
      fill: item.fill
    };
  });

  const getLabel = ({ name, value }) => {
    return `${name}: ${isPercentage ? formatToPercentage(value) : value}`;
  };

  return (
    <div className={classes.container}>
      {data.map((item) => (
        <div key={item.name} className={classes.item}>
          <div style={{ backgroundColor: item.fill }} className={classes.colorBox} />
          <div>{getLabel(item)}</div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(TooltipContent);
